export default function parseUri(uri_path) {
    let params = new URLSearchParams(uri_path.split('?')[1]);
    //const action = uri_path.split('?')[0].split('://')[1];
    const result = {};
    params.forEach((value, key) => {
        result[key] = value;
    })
    return result
}
